import { Box, TextField, IconButton, Chip, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton } from "../soft/SoftKit";

function isRowValid(row, maxPage) {
  const s = Number(row.startPage);
  const e = Number(row.endPage);
  if (!Number.isFinite(s) || !Number.isFinite(e)) return false;
  if (s < 1 || e < 1) return false;
  if (s > e) return false;
  if (maxPage > 0 && (s > maxPage || e > maxPage)) return false;
  return true;
}

export default function PageRangeEditor({
  assignedRanges,
  rows,
  onChange,
  maxPage,
}) {
  const { t } = useScriptMode();

  const updateRow = (i, patch) =>
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const addRow = () => onChange([...rows, { startPage: "", endPage: "" }]);
  const removeRow = (i) => onChange(rows.filter((_, idx) => idx !== i));

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      {Array.isArray(assignedRanges) && assignedRanges.length > 0 ? (
        <Box display="flex" gap={0.5} flexWrap="wrap">
          {assignedRanges.map((r, i) => (
            <Chip
              key={`${r.startPage}-${r.endPage}-${i}`}
              size="small"
              label={`${r.startPage}–${r.endPage}`}
              variant="outlined"
            />
          ))}
        </Box>
      ) : null}

      <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
        {t("hatim_progress_modal_ranges_label")}
      </Typography>

      {rows.length === 0 ? (
        <Typography variant="caption" color="text.secondary">
          {t("hatim_range_add")}
        </Typography>
      ) : null}

      {rows.map((row, i) => {
        const valid = isRowValid(row, maxPage);
        return (
          <Box key={i} display="flex" gap={1} alignItems="center">
            <TextField
              type="number"
              size="small"
              label={t("hatim_range_start")}
              value={row.startPage}
              onChange={(e) => updateRow(i, { startPage: e.target.value })}
              inputProps={{ min: 1, max: maxPage || undefined }}
              sx={{ width: 130 }}
              error={!!row.startPage && !valid}
            />
            <TextField
              type="number"
              size="small"
              label={t("hatim_range_end")}
              value={row.endPage}
              onChange={(e) => updateRow(i, { endPage: e.target.value })}
              inputProps={{ min: 1, max: maxPage || undefined }}
              sx={{ width: 130 }}
              error={!!row.endPage && !valid}
            />
            <IconButton aria-label={`remove-row-${i}`} onClick={() => removeRow(i)} size="small">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        );
      })}

      <SoftButton tone="soft" onClick={addRow} sx={{ alignSelf: "flex-start" }}>
        {t("hatim_range_add")}
      </SoftButton>
    </Box>
  );
}
